import { headers_custom_func_get } from "../Auth/get_set_AuthHeaders";
import { apiUriHttp } from "../conf/apiConf";

export async function putData_byApiNameAndData(apiName: string, DataToSend: any, baseUri: string = apiUriHttp()): Promise<any> {
  //console.log(apiName, ' called with ', DataToSend );
  try {
    const response = await fetch(baseUri + apiName, {
      method: 'PUT',
      headers: headers_custom_func_get(),
      body: JSON.stringify(DataToSend),
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error(`Failed to fetch data for ${apiName}`);
    }
    else{
      const data: any = await response.json();
      //console.log(data)
      return data.responseData;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}
